import React, { useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Typography, Select, MenuItem, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Pagination';
import blend from '../../../../assests/Blend.svg';
import { fetchProducts, deleteProduct, editProduct } from '../../../Redux/Slice/productSlice';

const ProductList = () => {
  const dispatch = useDispatch();
  const { products } = useSelector(state => state.products);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);
  const productsPerPage = 5;


  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);
  const filteredProducts = Array.isArray(products)
    ? products.filter((product) => {
        return (
          (selectedProduct ? product.name.includes(selectedProduct) : true) &&
          (selectedStatus ? product.status === selectedStatus : true)
        );
      })
    : [];

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handleDelete = (productId) => {
    dispatch(deleteProduct(productId)); 
  };

  const handleEdit = (product) => {
    setProductToEdit(product);
    setOpenEditDialog(true);
  };

  const handleEditSubmit = () => {
    dispatch(editProduct(productToEdit)); 
    setOpenEditDialog(false);
  };

  const handleEditChange = (e) => {
    setProductToEdit({
      ...productToEdit,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        Products List
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mb: 2,
          flexWrap: 'wrap',
        }}
      >
        <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
          <InputLabel>Product</InputLabel>
          <Select
            value={selectedProduct}
            onChange={(event) => setSelectedProduct(event.target.value)}
            label="Product"
            fullWidth
          >
            <MenuItem value="">All Products</MenuItem>
            {Array.isArray(products) &&
              products.map((product) => (
                <MenuItem key={product.id} value={product.name}>
                  {product.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl> 

        <FormControl sx={{ minWidth: 200, marginRight: 2 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={selectedStatus}
            onChange={(event) => setSelectedStatus(event.target.value)}
            label="Status"
            fullWidth
          >
            <MenuItem value="">All Status</MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Archived">Archived</MenuItem>
            <MenuItem value="Refund">Refund</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Select</TableCell>
              <TableCell>Product Name</TableCell>
              {selectedProduct && <TableCell>Image</TableCell>}
              <TableCell>Price</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentProducts.map((product) => (
              <TableRow key={product.id}>
                <TableCell>
                  <input type="checkbox" />
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={blend}
                      alt={product.name}
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        marginRight: "8px",
                      }}
                    />
                    <Typography>{product.name}</Typography>
                  </Box>
                </TableCell>
                {selectedProduct && (
                  <TableCell>
                    <img
                      src={blend}
                      alt={product.name}
                      style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '10px' }}
                    />
                  </TableCell>
                )}
                <TableCell>{product.original_price}</TableCell>
                <TableCell>
                  <Typography
                    variant="body2"
                    sx={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color:
                        product.status === 'Active'
                          ? '#3bb77e'
                          : product.status === 'Archived'
                          ? 'orange'
                          : 'red',
                      backgroundColor:
                        product.status === 'Active'
                          ? 'rgba(0, 128, 0, 0.1)'
                          : product.status === 'Refund'
                          ? 'rgba(255, 165, 0, 0.1)'
                          : 'rgba(255, 0, 0, 0.1)',
                      fontWeight: 'bold',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {product.status}
                  </Typography>
                </TableCell>
                <TableCell>{product.created_at}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: '#3bb77e',
                      color: '#fff',
                      marginRight: 1,
                      width: { xs: '100%', sm: 'auto' },
                    }}
                    onClick={() => handleEdit(product)}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: '#fff',
                      color: '#3bb77e',
                      border: '1px solid #3bb77e',
                      width: { xs: '100%', sm: 'auto' },
                    }}
                    onClick={() => handleDelete(product.id)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Pagination
        totalPages={Math.ceil(filteredProducts.length / productsPerPage)}
        currentPage={currentPage}
        onPageChange={(event, value) => setCurrentPage(value)}
      />

      <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)}>
        <DialogTitle>Edit Product</DialogTitle>
        <DialogContent>
          <TextField
            label="Product Name"
            name="name"
            value={productToEdit?.name || ''}
            onChange={handleEditChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Price"
            name="price"
            value={productToEdit?.price || ''}
            onChange={handleEditChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Status"
            name="status"
            value={productToEdit?.status || ''}
            onChange={handleEditChange}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Date"
            name="is_created"
            value={productToEdit?.is_created || ''}
            onChange={handleEditChange}
            fullWidth
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProductList;
